import React from "react";


export default function Button(props) {
  return <button
    className={`ds-button ${props.type ? props.type : 'primary'} ${props.loading ? 'loading' : ''}`}
    style={props.disabled ? {
      opacity: 0.5,
      cursor: 'not-allowed',
    } : {}}
    type="button"
    disabled={props.disabled}
    onClick={props.onclick}
  >
    {props.label}
  </button>
}


/*

Usage:

<Button type="" label="" onclick={} />

- type (Optional): secondary / destructive
- label: String
- onclick (Optional)

*/
